// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__13IiR","header":"ReportDetails_header__2r8Oe","title":"ReportDetails_title__3_99k","left":"ReportDetails_left__1O7FC"};